(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const libsReady = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && typeof Lenis !== 'undefined';
  if (prefersReduced || !libsReady) return;
  gsap.registerPlugin(ScrollTrigger);

  /* Lenis: slow, heavy glide for the luxury cadence */
  const lenis = new Lenis({
    lerp: 0.075, smoothWheel: true, smoothTouch: false,
    wheelMultiplier: 0.75, touchMultiplier: 1.3,
    duration: 1.6,
    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(t => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);

  /* (2) Doctrine scroll lighting removed 2026-10-07 (Chen): section 01 is static text. */

  /* (3) Hairline rules — draw across each chapter on enter */
  document.querySelectorAll('.chapter-rule').forEach(rule => {
    gsap.to(rule, {
      scaleX: 1, duration: 1.8, ease: 'expo.out',
      scrollTrigger: { trigger: rule, start: 'top 78%' }
    });
  });

  /* Standard statements — slow fade-in per viewport */
  gsap.utils.toArray('.standard__statement').forEach(st => {
    gsap.from(st.querySelector('.standard__sentence'), {
      opacity: 0, y: 30, duration: 1.6, ease: 'expo.out',
      scrollTrigger: { trigger: st, start: 'top 60%' }
    });
    gsap.from(st.querySelector('.standard__index'), {
      opacity: 0, y: 14, duration: 1.2, delay: 0.15, ease: 'power3.out',
      scrollTrigger: { trigger: st, start: 'top 60%' }
    });
  });

  /* Discipline beats — sequential reveal */
  gsap.utils.toArray('.beat').forEach((b, i) => {
    gsap.to(b, {
      opacity: 1, y: 0, duration: 1.4, ease: 'expo.out', delay: 0.1,
      scrollTrigger: { trigger: b, start: 'top 80%' }
    });
  });

  /* Engagement capacity + inclusions fade */
  gsap.from('.engagement__capacity > *', {
    opacity: 0, y: 18, duration: 1.4, ease: 'expo.out', stagger: 0.12,
    scrollTrigger: { trigger: '.engagement', start: 'top 72%' }
  });
  gsap.utils.toArray('.service').forEach(function (s, i) {
    gsap.to(s, {
      opacity: 1, y: 0, duration: 1.4, ease: 'expo.out', delay: 0.08,
      scrollTrigger: { trigger: s, start: 'top 82%' }
    });
  });
  gsap.from('.engagement__foot', {
    opacity: 0, y: 12, duration: 1.2, ease: 'power3.out',
    scrollTrigger: { trigger: '.engagement__foot', start: 'top 88%' }
  });

  /* Brief — form fields stagger in */
  gsap.from('.brief__head > *', {
    opacity: 0, y: 16, duration: 1.3, ease: 'expo.out', stagger: 0.08,
    scrollTrigger: { trigger: '.brief', start: 'top 76%' }
  });
  gsap.from('.brief__form .field', {
    opacity: 0, y: 18, duration: 1.2, ease: 'power3.out', stagger: 0.07,
    scrollTrigger: { trigger: '.brief__form', start: 'top 82%' }
  });
  gsap.from('.brief__submit-row', {
    opacity: 0, y: 16, duration: 1.2, ease: 'expo.out',
    scrollTrigger: { trigger: '.brief__submit-row', start: 'top 92%' }
  });

  /* Reply — slow fade */
  gsap.from('.reply > *', {
    opacity: 0, y: 14, duration: 1.6, ease: 'expo.out', stagger: 0.18,
    scrollTrigger: { trigger: '.reply', start: 'top 80%' }
  });

  /* (4) Custom cursor + cursor-tracking soft light */
  const cursor = document.querySelector('.cursor');
  const light  = document.querySelector('.cursor-light');
  let mx = window.innerWidth / 2, my = window.innerHeight / 2;
  let lx = mx, ly = my, cx = mx, cy = my;
  window.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
  function raf() {
    cx += (mx - cx) * 0.22; cy += (my - cy) * 0.22;
    lx += (mx - lx) * 0.07; ly += (my - ly) * 0.07;
    if (cursor) cursor.style.transform = `translate3d(${cx}px,${cy}px,0)`;
    if (light)  light.style.transform  = `translate3d(${lx}px,${ly}px,0)`;
    requestAnimationFrame(raf);
  }
  raf();
  document.querySelectorAll('a, button, input, select, textarea, label').forEach(el => {
    el.addEventListener('mouseenter', () => cursor && cursor.classList.add('is-link'));
    el.addEventListener('mouseleave', () => cursor && cursor.classList.remove('is-link'));
  });

  /* (5) Velocity scroll blur removed 2026-10-07 (Chen). */

  /* ═══ Damascus flow — silver contour terrain + cursor ripples ═══
     Silver-white contour isolines (4-octave fbm marching-squares) drift
     slowly over a soft gold wash — the SEO Content Authority hero's drift,
     restyled with white lines.
     On top, a height-field water simulation runs on the same grid: moving
     the pointer drops energy in, waves propagate + interfere and settle with
     damping, and the lines REFRACT through the surface gradient so dragging
     feels liquid. Always-on; renders each frame. */
  (function(){
    var c = document.getElementById('heroCanvas');
    if (!c) return;
    var ctx = c.getContext('2d');
    var W=0, H=0, dpr = Math.min(window.devicePixelRatio||1, 2);

    function hash(ix, iy){ var s = Math.sin(ix*374.31 + iy*561.13) * 91237.7; return s - Math.floor(s); }
    function smoothstep(t){ return t*t*(3-2*t); }
    function valNoise(x, y){
      var ix=Math.floor(x), iy=Math.floor(y), fx=x-ix, fy=y-iy;
      var a=hash(ix,iy), b=hash(ix+1,iy), cc=hash(ix,iy+1), d=hash(ix+1,iy+1);
      var ux=smoothstep(fx), uy=smoothstep(fy);
      return (a*(1-ux)+b*ux)*(1-uy) + (cc*(1-ux)+d*ux)*uy;
    }
    function fbm(x, y){
      var v=0, amp=0.5, freq=1;
      for (var i=0;i<4;i++){ v += amp*valNoise(x*freq, y*freq); freq*=2; amp*=0.5; }
      return v;
    }

    /* ── tunables ── */
    var step    = 12;     /* grid resolution (px). smaller = finer water, more CPU */
    var DAMP    = 0.96;   /* wave damping — higher = ripples linger longer */
    var IMPULSE = 0.55;   /* how much a fast drag dents the surface */
    var IMP_MAX = 46;     /* cap on a single dent */
    var GDISP   = 0.9;    /* refraction strength — how hard lines bend */
    var GDISP_MAX = 26;   /* cap on the refraction offset (px) */
    var FLOW_SPEED = 0.0014;  /* terrain drift speed (matches the SEO hero) */
    var flowT = 0;            /* flow time accumulator */

    /* ── grid buffers (allocated on resize) ── */
    var nx=0, ny=0, cur, prev, nxt, grid;
    function alloc(){
      nx = Math.ceil(W/step) + 2; ny = Math.ceil(H/step) + 2;
      var n = nx*ny;
      cur  = new Float32Array(n); prev = new Float32Array(n);
      nxt  = new Float32Array(n); grid = new Float32Array(n);
    }
    function resize(){
      var r = c.getBoundingClientRect();
      W = r.width; H = r.height;
      c.width = W*dpr; c.height = H*dpr;
      ctx.setTransform(dpr,0,0,dpr,0,0);
      alloc();
    }

    /* ── pointer ── */
    var mx=-9999, my=-9999, lastMX=-9999, lastMY=-9999;
    window.addEventListener('mousemove', function(e){ mx = e.clientX; my = e.clientY; });

    /* Drop energy into the surface at the cursor, scaled by drag speed. A
       small disc keeps the dent smooth; injecting every frame along the
       path leaves a wake as the pointer moves. */
    function inject(){
      if (mx < -9000) return;
      if (lastMX < -9000){ lastMX = mx; lastMY = my; }
      var ddx = mx-lastMX, ddy = my-lastMY;
      lastMX = mx; lastMY = my;
      var spd = Math.sqrt(ddx*ddx + ddy*ddy);
      var imp = Math.min(spd * IMPULSE, IMP_MAX);
      if (imp < 0.4) return;
      var cix = Math.round(mx/step), ciy = Math.round(my/step);
      for (var oy=-2; oy<=2; oy++){
        for (var ox=-2; ox<=2; ox++){
          var gx2 = cix+ox, gy2 = ciy+oy;
          if (gx2<1 || gx2>nx-2 || gy2<1 || gy2>ny-2) continue;
          var w = Math.max(0, 1 - (ox*ox+oy*oy)/8);
          cur[gy2*nx + gx2] -= imp * w;
        }
      }
    }

    /* Classic two-buffer wave step: each cell relaxes toward the average of
       its 4 neighbours, minus its previous value, then damped. */
    function stepSim(){
      for (var iy=1; iy<ny-1; iy++){
        var rowo = iy*nx;
        for (var ix=1; ix<nx-1; ix++){
          var i = rowo + ix;
          nxt[i] = ((cur[i-1]+cur[i+1]+cur[i-nx]+cur[i+nx]) * 0.5 - prev[i]) * DAMP;
        }
      }
      var t = prev; prev = cur; cur = nxt; nxt = t;
    }

    /* Drifting "peaks" — gaussian elevation bumps (no labels) that move and
       bounce off the margins, so the contour ridges flow and morph. This is
       the core of why the SEO hero reads as alive, not just sliding noise. */
    var peaks = [
      { x:0.22, y:0.32, vx: 0.00060, vy: 0.00038 },
      { x:0.72, y:0.40, vx:-0.00050, vy: 0.00065 },
      { x:0.46, y:0.66, vx: 0.00033, vy:-0.00045 },
      { x:0.78, y:0.55, vx:-0.00072, vy:-0.00028 },
      { x:0.12, y:0.78, vx: 0.00080, vy:-0.00058 }
    ];
    var PB = { xMin:0.04, xMax:0.96, yMin:0.08, yMax:0.92 };
    function stepPeaks(){
      for (var i=0;i<peaks.length;i++){
        var p=peaks[i]; p.x+=p.vx; p.y+=p.vy;
        if (p.x<PB.xMin){ p.x=PB.xMin; p.vx=-p.vx; } else if (p.x>PB.xMax){ p.x=PB.xMax; p.vx=-p.vx; }
        if (p.y<PB.yMin){ p.y=PB.yMin; p.vy=-p.vy; } else if (p.y>PB.yMax){ p.y=PB.yMax; p.vy=-p.vy; }
      }
    }

    /* Height field = drifting low-freq noise + moving peaks, sampled through
       the water-refraction offset (oX/oY), then marching-squared. */
    function buildGrid(){
      for (var iy=0; iy<ny; iy++){
        var rowo = iy*nx;
        for (var ix=0; ix<nx; ix++){
          var i = rowo + ix;
          var gx=0, gy=0;
          if (ix>0 && ix<nx-1 && iy>0 && iy<ny-1){
            gx = cur[i+1] - cur[i-1];
            gy = cur[i+nx] - cur[i-nx];
          }
          var oX = gx*GDISP; if (oX>GDISP_MAX) oX=GDISP_MAX; else if (oX<-GDISP_MAX) oX=-GDISP_MAX;
          var oY = gy*GDISP; if (oY>GDISP_MAX) oY=GDISP_MAX; else if (oY<-GDISP_MAX) oY=-GDISP_MAX;
          var fx = (ix*step - oX) / W, fy = (iy*step - oY) / H;
          var hVal = fbm(fx*3.4 + flowT, fy*3.0 + flowT*0.6);
          for (var pi=0; pi<peaks.length; pi++){
            var pk = peaks[pi], ddx = fx-pk.x, ddy = fy-pk.y;
            hVal += 0.55 * Math.exp(-(ddx*ddx + ddy*ddy) * 22);
          }
          grid[i] = hVal;
        }
      }
    }

    var levels = [0.32, 0.42, 0.52, 0.62, 0.72, 0.82, 0.92, 1.02, 1.12, 1.22];
    function lerp(va, vb, level){ return (level - va) / (vb - va + 1e-9); }
    function drawContour(level, alpha, weight){
      ctx.beginPath();
      for (var iy=0; iy<ny-1; iy++){
        for (var ix=0; ix<nx-1; ix++){
          var v0=grid[iy*nx+ix], v1=grid[iy*nx+ix+1], v2=grid[(iy+1)*nx+ix+1], v3=grid[(iy+1)*nx+ix];
          var b0=v0>level?1:0, b1=v1>level?1:0, b2=v2>level?1:0, b3=v3>level?1:0;
          var idx = b0 | (b1<<1) | (b2<<2) | (b3<<3);
          if (idx === 0 || idx === 15) continue;
          var x0 = ix*step, y0 = iy*step;
          var et = [x0+step*lerp(v0,v1,level), y0];
          var er = [x0+step,                    y0+step*lerp(v1,v2,level)];
          var eb = [x0+step*lerp(v3,v2,level), y0+step];
          var el = [x0,                         y0+step*lerp(v0,v3,level)];
          function seg(a, b){ ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); }
          switch(idx){
            case 1: case 14: seg(et, el); break;
            case 2: case 13: seg(et, er); break;
            case 3: case 12: seg(el, er); break;
            case 4: case 11: seg(er, eb); break;
            case 5:          seg(et, el); seg(er, eb); break;
            case 6: case 9:  seg(et, eb); break;
            case 7: case 8:  seg(el, eb); break;
            case 10:         seg(et, er); seg(el, eb); break;
          }
        }
      }
      ctx.strokeStyle = 'rgba(214,219,226,' + alpha + ')';
      ctx.lineWidth = weight;
      ctx.stroke();
    }
    function draw(){
      ctx.clearRect(0, 0, W, H);
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (var li=0; li<levels.length; li++){
        var isMajor = li % 3 === 0;
        drawContour(levels[li], isMajor ? 0.42 : 0.18, isMajor ? 1.0 : 0.55);
      }
    }

    function loop(){
      flowT += FLOW_SPEED;   /* the whole field is always slowly flowing */
      stepPeaks();           /* drift the elevation peaks → ridges flow + morph */
      inject();
      stepSim();
      buildGrid();
      draw();
      requestAnimationFrame(loop);
    }
    resize();
    window.addEventListener('resize', resize);
    loop();
  })();

  /* Scroll-percent indicator */
  const pct = document.getElementById('pct');
  if (pct) {
    function upd() {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      pct.textContent = String(Math.round(p * 100)).padStart(3, '0');
    }
    lenis.on('scroll', upd); upd();
  }
})();
